import styled, { css } from 'styled-components';
import { baseVariables } from '../../styles';

const SHADOW = '0 0.125rem 0.625rem 0 rgba(0,0,0,0.07)';
const base10 = baseVariables?.color?.base10 ?? '#1c1c1c';
const base20 = baseVariables?.color?.base20 ?? '#ffffff';
const neutral30 = baseVariables?.color?.neutral30 ?? '#c4c4c4';

export const ArrowButton = styled.button<{ $transparent: boolean }>`
  --icon-color: var(--t-color-control-foreground, ${base10});
  --drop-shadow: ${SHADOW};
  display: flex;
  align-items: center;
  justify-content: center;
  block-size: 2.5rem;
  inline-size: 2.5rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: var(--icon-color);
  transition: background-color 300ms ease-out, backdrop-filter 300ms ease-out, box-shadow 300ms ease-out,
    color 300ms ease-out;

  ${({ $transparent }) =>
    $transparent
      ? css`
          --icon-color: var(--t-color-control-foreground-reverse, ${base20});
          background-color: var(--t-color-control-background-overlay, rgba(255, 255, 255, 0.54));
          backdrop-filter: blur(2px);
          box-shadow: none;
        `
      : css`
          background-color: var(--t-color-control-background, ${base10});
          box-shadow: var(--drop-shadow);
        `}

  &:focus:not(:disabled) {
    outline: 2px solid -webkit-focus-ring-color;
  }

  &:disabled {
    --icon-color: ${neutral30};
    pointer-events: none;
  }

  .icon {
    color: var(--icon-color);
  }
`;
